import { getGlobals } from "src/constants/globals";
import { sanitizeSearchTerm } from "src/utils/sanitize-search-term";

interface IReturnObject {
    getExtendedSearchUrl: (searchTerm: string | undefined) => string;
}

export const useExtendedSearchUrl = (): IReturnObject => {
    const globals = getGlobals();

    const getExtendedSearchUrl = (searchTerm: string | undefined) => {
        if (!globals.routes.searchExtended) {
            return "/";
        }

        return [`${globals.routes.searchExtended}?`, searchTerm ? `searchTerm=${encodeURIComponent(sanitizeSearchTerm(searchTerm))}` : null]
            .filter(Boolean)
            .join("");
    };

    return { getExtendedSearchUrl };
};
